export default __webpack_public_path__ + "static/media/tb-team-michael.31547709.jpg";